<template>
  <el-container>
    <el-header height="220">
      <h3>SpringCloud 网关路由</h3>
    </el-header>
    <el-main>
      <el-table
        :data="dataList"
        border
        height="480"
        style="width: 100%"
      >
        <el-table-column
          fixed="left"
          label="No"
          type="index"
        />
        <el-table-column
          prop="id"
          label="路由 ID"
        />
        <el-table-column
          prop="upstreamUrl"
          label="上游服务"
        />
        <el-table-column
          prop="routeUrl"
          label="匹配 URL"
        />
        <el-table-column
          fixed="right"
          label="操作"
          width="280"
        >
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="handleEdit(scope.$index, scope.row)"
            >编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
  </el-container>
</template>

<script>
import { getGatewayRoute } from '@/api/tnb'

export default {
  name: 'AdminGateway',
  data() {
    return {
      // 屏幕宽度, 为了控制分页条的大小
      screenWidth: document.body.clientWidth,
      currentPage: 1,
      pageSize: 12,
      totalSize: 0,
      dataList: [],
      nextId: 0
    }
  },
  created() {
    document.title = 'SpringCloud 网关'
    this.getData()
  },
  methods: {
    getData() {
      getGatewayRoute().then(resp => {
        if (resp.code === 0) {
          this.dataList = resp.data
        } else {
          this.$message.error(resp.msg)
        }
      })
    },
    handleEdit(index, row) {
      this.$message.info('handle edit')
    }
  }
}
</script>

<style>
</style>
